import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page-wrapper" }
const _hoisted_2 = { class: "form-card" }
const _hoisted_3 = {
  id: "field-policyNumber",
  class: "form-item-wrapper red-text-label"
}
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}
const _hoisted_5 = {
  id: "field-contactName",
  class: "form-item-wrapper red-text-label"
}
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}
const _hoisted_7 = {
  id: "field-contactPhone",
  class: "form-item-wrapper red-text-label"
}
const _hoisted_8 = {
  key: 0,
  class: "error-message"
}
const _hoisted_9 = { class: "form-item-wrapper flex-col" }
const _hoisted_10 = { class: "form-item-wrapper" }
const _hoisted_11 = { class: "form-item-wrapper" }
const _hoisted_12 = { class: "form-item-wrapper" }
const _hoisted_13 = {
  id: "field-registeredVehicleNumber",
  class: "form-item-wrapper red-text-label"
}
const _hoisted_14 = {
  key: 0,
  class: "error-message"
}
const _hoisted_15 = {
  id: "field-accidentDate",
  class: "form-item-wrapper flex-col"
}
const _hoisted_16 = {
  key: 0,
  class: "error-message"
}
const _hoisted_17 = {
  id: "field-accidentTime",
  class: "form-item-wrapper red-text-label"
}
const _hoisted_18 = {
  id: "field-accidentLocation",
  class: "form-item-wrapper red-text-label"
}
const _hoisted_19 = {
  key: 0,
  class: "error-message"
}
const _hoisted_20 = { class: "form-item-wrapper" }
const _hoisted_21 = { class: "form-item-wrapper" }
const _hoisted_22 = { class: "form-item-wrapper checkbox-row" }
const _hoisted_23 = { class: "form-item-wrapper flex-col" }
const _hoisted_24 = { class: "form-item-wrapper flex-col" }
const _hoisted_25 = { class: "form-item-wrapper" }
const _hoisted_26 = { class: "form-item-wrapper" }
const _hoisted_27 = { class: "form-item-wrapper flex-col" }
const _hoisted_28 = { class: "form-item-wrapper checkbox-row" }
const _hoisted_29 = { class: "form-item-wrapper" }
const _hoisted_30 = {
  id: "field-accidentDetails",
  class: "form-item-wrapper"
}
const _hoisted_31 = {
  key: 0,
  class: "error-message"
}
const _hoisted_32 = { class: "form-item-wrapper" }
const _hoisted_33 = { class: "submit-wrapper" }

import { nextTick, reactive, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import dayjs, { Dayjs } from 'dayjs'
import CommonInput from '@/common/formControls/CommonInput.vue'
import TimeInput from '@/common/formControls/TimeInput.vue'
import {
  formatAccidentTime,
  toIdPayload,
  validateFnolForm,
  validateFnolField,
  FormValidationRules,
  SelectOption
} from '@/common/utils/CommonUtils'
import { formatDigitOnly } from '@/common/utils/newUtils/FormatUtils'
import MainTemplate from '@/components/MainTemplate.vue'

interface FormState {
  policyNumber: string
  contactName: string
  contactPhone: string
  relationshipWithContractor: string
  contractorNameKana: string
  contractorName: string
  contractorPhone: string
  registeredVehicleNumber: string
  accidentDate: string | null
  accidentTime: string
  accidentLocation: string
  driverNameKana: string
  driverName: string
  isContractorHimself: boolean
  gender: string | undefined
  birthDate: string | null
  age: string
  driverPhone: string
  driverRelationshipWithContractor: string
  isSameAsContractedVehicle: boolean
  accidentVehicleNumber: string
  accidentDetails: string
  otherNotes: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FnolInputForm',
  setup(__props) {

const router = useRouter()
const route = useRoute()

// Key order matching top-to-bottom layout for smooth scrolling & focus
const fieldOrder: (keyof FormValidationRules)[] = [
  'policyNumber',
  'contactName',
  'contactPhone',
  'registeredVehicleNumber',
  'accidentDate',
  'accidentTime',
  'accidentLocation',
  'accidentDetails'
]

// 性別
const genderOptions: SelectOption[] = [
  { key: 'male', id: 1, description: 'termsAndConditions.gender.male' },
  { key: 'female', id: 2, description: 'termsAndConditions.gender.female' }
]

// ご契約者様との関係
const relationshipOptions: SelectOption[] = [
  { key: 'self', id: 1, description: 'termsAndConditions.relationshipToCustomer.self' },
  { key: 'driver', id: 9, description: 'termsAndConditions.relationshipToCustomer.driver' },
  { key: 'family', id: 9, description: 'termsAndConditions.relationshipToCustomer.family' },
  { key: 'agency', id: 6, description: 'termsAndConditions.relationshipToCustomer.agency' },
  { key: 'other', id: 9, description: 'termsAndConditions.relationshipToCustomer.other' }
]

// 運転者とご契約者様との関係
const driverRelationshipOptions: SelectOption[] = [
  { key: 'self', id: 1, description: 'termsAndConditions.customerToNamedInsured.self' },
  { key: 'spouse', id: 2, description: 'termsAndConditions.customerToNamedInsured.spouse' },
  {
    key: 'childLivingTogether',
    id: 8,
    description: 'termsAndConditions.customerToNamedInsured.childLivingTogether'
  },
  {
    key: 'childNotLivingTogether',
    id: 0,
    description: 'termsAndConditions.customerToNamedInsured.childNotLivingTogether'
  },
  { key: 'family', id: 7, description: 'termsAndConditions.customerToNamedInsured.family' },
  { key: 'employee', id: 4, description: 'termsAndConditions.customerToNamedInsured.employee' },
  { key: 'friend', id: 5, description: 'termsAndConditions.customerToNamedInsured.friend' },
  { key: 'other', id: 9, description: 'termsAndConditions.customerToNamedInsured.other' }
]

const formData = reactive<FormState>({
  policyNumber: '',
  contactName: '',
  contactPhone: '',
  relationshipWithContractor: '',
  contractorNameKana: '',
  contractorName: '',
  contractorPhone: '',
  registeredVehicleNumber: '',
  accidentDate: null,
  accidentTime: '',
  accidentLocation: '',
  driverNameKana: '',
  driverName: '',
  isContractorHimself: false,
  gender: undefined,
  birthDate: null,
  age: '',
  driverPhone: '',
  driverRelationshipWithContractor: '',
  isSameAsContractedVehicle: false,
  accidentVehicleNumber: '',
  accidentDetails: '',
  otherNotes: ''
})

// Validation Error State
const errors = reactive<Record<string, string>>({
  policyNumber: '',
  contactName: '',
  contactPhone: '',
  registeredVehicleNumber: '',
  accidentDate: '',
  accidentTime: '',
  accidentLocation: '',
  accidentDetails: ''
})

// Helper to map payload object { id, description } or direct string back to select option key
const getOptionKey = (options: SelectOption[], val: any): string => {
  if (!val) return ''
  if (typeof val === 'string') return val
  if (typeof val === 'object' && val.description) {
    const found = options.find((opt) => opt.description === val.description)
    return found ? found.key : ''
  }
  return ''
}

// Extract query parameters and bind to form state
const initializeFormFromQuery = () => {
  const rawData = route.query.data
  if (!rawData || typeof rawData !== 'string') return

  try {
    const data = JSON.parse(rawData)

    formData.policyNumber = data.policyNumber ?? ''
    formData.contactName = data.c1FullName ?? ''
    formData.contactPhone = data.c1Tel ?? ''
    formData.contractorNameKana = data.c1ContractNameKana ?? ''
    formData.contractorName = data.c1ContractFullName ?? ''
    formData.contractorPhone = data.c1HomeTel ?? ''
    formData.registeredVehicleNumber = data.c1RegistraNum ?? ''
    formData.accidentTime = data.c2AccidentTime ?? ''
    formData.accidentLocation = data.c2JikoPlace ?? ''
    formData.driverNameKana = data.c2DriverNameKara ?? ''
    formData.driverName = data.c2DriverFullName ?? ''
    formData.age = data.c2DriverAge ?? ''
    formData.driverPhone = data.c2DriverTel ?? ''
    formData.accidentVehicleNumber = data.c2RegistraNum ?? ''
    formData.accidentDetails = data.c2AccidentConditionText ?? ''
    formData.otherNotes = data.c2SpecialItem ?? ''

    // Date formatting using Dayjs
    formData.accidentDate = data.c2AccidentDate
      ? dayjs(data.c2AccidentDate).format('YYYY/MM/DD')
      : null
    formData.birthDate = data.c2DriverDob ? dayjs(data.c2DriverDob).format('YYYY/MM/DD') : null

    // Checkbox statuses
    formData.isContractorHimself = Boolean(data.c2DriverDobStatus) || data.c2Contracter === '1'
    formData.isSameAsContractedVehicle = Boolean(data.c2RegistraNumStatus)

    // Select Dropdown mappings
    formData.relationshipWithContractor = getOptionKey(relationshipOptions, data.c1InsuRlRelation)
    formData.gender = getOptionKey(genderOptions, data.c2Sex)
    formData.driverRelationshipWithContractor = getOptionKey(
      driverRelationshipOptions,
      data.c2InsuRlRelation
    )
  } catch (err) {
    console.error('Failed to parse URL query data:', err)
  }
}

const handleEnter = (e: KeyboardEvent) => {
  const target = e.target as HTMLElement | null
  if (!target) return

  // Allow Enter key to insert newlines inside textareas
  if (target.tagName === 'TEXTAREA') return

  // Prevent default form submit behavior
  e.preventDefault()

  const formElement = document.querySelector('.form-content')
  if (!formElement) return

  // Query all visible, non-disabled input elements in DOM order
  const focusableSelector = [
    'input:not([disabled]):not([type="hidden"])',
    'textarea:not([disabled])',
    '.ant-select-selection-search-input',
    'button:not([disabled])'
  ].join(', ')

  const focusables = Array.from(
    formElement.querySelectorAll<HTMLElement>(focusableSelector)
  ).filter((el) => el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0)

  const currentIndex = focusables.indexOf(target)

  // Move focus to the next element if available
  if (currentIndex !== -1 && currentIndex < focusables.length - 1) {
    focusables[currentIndex + 1].focus()
  }
}

onMounted(() => {
  initializeFormFromQuery()
})

const handleBlur = (field: keyof FormValidationRules) => {
  errors[field] = validateFnolField(field, formData[field])
}

const handleTimeBlur = () => {
  formData.accidentTime = formatAccidentTime(formatDigitOnly(formData.accidentTime))
  handleBlur('accidentTime')
}

const clearError = (field: string) => {
  if (errors[field]) {
    errors[field] = ''
  }
}

const focusFirstErrorField = () => {
  nextTick(() => {
    const firstErrorKey = fieldOrder.find((key) => !!errors[key])

    if (firstErrorKey) {
      const wrapperElement = document.getElementById(`field-${firstErrorKey}`)
      if (wrapperElement) {
        const inputElement = wrapperElement.querySelector<HTMLElement>(
          'input, textarea, .ant-picker, .ant-select'
        )

        if (inputElement) {
          inputElement.focus()
        }

        wrapperElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
  })
}

const disabledDate = (current: Dayjs) => {
  return current && current > dayjs().endOf('day')
}

watch(
  () => formData.isContractorHimself,
  (isSelf) => {
    if (isSelf) {
      // formData.gender = undefined
      formData.birthDate = ''
      // formData.age = ''
      formData.driverPhone = formData.contactPhone || ''
    }
  }
)

watch(
  () => formData.isSameAsContractedVehicle,
  (isSelf) => {
    if (isSelf) {
      formData.accidentVehicleNumber = formData.registeredVehicleNumber || ''
    }
  }
)

const handleSubmit = () => {
  // Run validation utility
  const validation = validateFnolForm(formData)
  Object.assign(errors, validation.errors)

  if (!validation.isValid) {
    focusFirstErrorField()
    return
  }

  // Map dropdown selections to their { id, description } payload shape
  const genderPayload = toIdPayload(genderOptions, formData.gender)
  const relationshipPayload = toIdPayload(relationshipOptions, formData.relationshipWithContractor)
  const driverRelationshipPayload = toIdPayload(
    driverRelationshipOptions,
    formData.driverRelationshipWithContractor
  )

  // Construct payload object
  const payload = {
    c1FullName: (formData.contactName || '').trim(),
    c1Tel: (formData.contactPhone || '').trim(),
    c1InsuRlRelation: relationshipPayload,
    c1ContractNameKana: (formData.contractorNameKana || '').trim(),
    c1ContractFullName: (formData.contractorName || '').trim(),
    c1HomeTel: (formData.contractorPhone || '').trim(),
    c1RegistraNum: (formData.registeredVehicleNumber || '').trim(),
    c2AccidentTime: (formData.accidentTime || '').trim(),
    c2AccidentDate: formData.accidentDate ? new Date(formData.accidentDate).toISOString() : '',
    c2JikoPlace: (formData.accidentLocation || '').trim(),
    c2DriverNameKara: (formData.driverNameKana || '').trim(),
    c2DriverFullName: (formData.driverName || '').trim(),
    c2Contracter: formData.isContractorHimself ? '1' : '',
    c2Sex: genderPayload,
    c2DriverDob: (formData.birthDate || '').trim(),
    c2DriverAge: (formData.age || '').trim(),
    c2DriverTel: (formData.driverPhone || '').trim(),
    c2InsuRlRelation: driverRelationshipPayload,
    c2RegistraNum: (formData.accidentVehicleNumber || '').trim(),
    c2AccidentConditionText: (formData.accidentDetails || '').trim(),
    c2SpecialItem: (formData.otherNotes || '').trim(),
    policyNumber: (formData.policyNumber || '').trim(),
    c2RegistraNumStatus: formData.isSameAsContractedVehicle,
    c2DriverDobStatus: formData.isContractorHimself
  }

  // Redirect to /review
  router.push({
    path: '/review',
    query: {
      data: JSON.stringify(payload)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MainTemplate),
    _createElementVNode("div", _hoisted_2, [
      _cache[46] || (_cache[46] = _createElementVNode("div", { class: "form-header" }, "入力画面", -1)),
      _createVNode(_component_a_form, {
        layout: "vertical",
        class: "form-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(CommonInput, {
              value: formData.policyNumber,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formData.policyNumber) = $event)),
              label: "*証券番号（半角数字・15文字以内）",
              colLabel: "24",
              colSpan: "24",
              "is-custom-input": false,
              "is-policy-and-branch-no": true,
              maxlength: 16,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (clearError('policyNumber'))),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (handleBlur('policyNumber')))
            }, null, 8, ["value"]),
            (errors.policyNumber)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errors.policyNumber), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(CommonInput, {
              value: formData.contactName,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formData.contactName) = $event)),
              label: "*ご連絡者様のお名前",
              colLabel: "24",
              colSpan: "24",
              "is-custom-input": false,
              onInput: _cache[4] || (_cache[4] = ($event: any) => (clearError('contactName'))),
              onBlur: _cache[5] || (_cache[5] = ($event: any) => (handleBlur('contactName'))),
              maxlength: 40
            }, null, 8, ["value"]),
            (errors.contactName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(errors.contactName), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(CommonInput, {
              value: formData.contactPhone,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((formData.contactPhone) = $event)),
              label: "*ご連絡者様のお電話番号（半角数字・14文字以内）",
              colLabel: "24",
              colSpan: "24",
              "is-custom-input": false,
              "is-phone-number": true,
              maxlength: 16,
              onInput: _cache[7] || (_cache[7] = ($event: any) => (clearError('contactPhone'))),
              onBlur: _cache[8] || (_cache[8] = ($event: any) => (handleBlur('contactPhone')))
            }, null, 8, ["value"]),
            (errors.contactPhone)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(errors.contactPhone), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[37] || (_cache[37] = _createElementVNode("label", { class: "field-label" }, "ご契約者様との関係", -1)),
            _createVNode(_component_a_select, {
              value: formData.relationshipWithContractor,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((formData.relationshipWithContractor) = $event)),
              class: "custom-field",
              "allow-clear": ""
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(relationshipOptions, (option) => {
                  return _createVNode(_component_a_select_option, {
                    key: option.key,
                    value: option.key
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(option.description)), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(CommonInput, {
              value: formData.contractorNameKana,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((formData.contractorNameKana) = $event)),
              label: "ご契約者様のお名前（カナ）",
              colLabel: "24",
              colSpan: "24",
              "is-custom-input": false,
              maxlength: 70
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(CommonInput, {
              value: formData.contractorName,
              "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((formData.contractorName) = $event)),
              label: "ご契約者様のお名前",
              colLabel: "24",
              colSpan: "24",
              "is-custom-input": false,
              maxlength: 40
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(CommonInput, {
              value: formData.contractorPhone,
              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((formData.contractorPhone) = $event)),
              label: "ご契約者様のお電話番号（半角数字・14文字以内）",
              colLabel: "24",
              colSpan: "24",
              "is-custom-input": false,
              "is-phone-number": true,
              maxlength: 16,
              title: "電話番号は半角で入力してください"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(CommonInput, {
              value: formData.registeredVehicleNumber,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((formData.registeredVehicleNumber) = $event)),
              label: "*契約車両の登録番号（例：品川50Aあ1234）",
              colLabel: "24",
              colSpan: "24",
              "is-custom-input": false,
              "is-number-plate": true,
              onInput: _cache[14] || (_cache[14] = ($event: any) => (clearError('registeredVehicleNumber'))),
              onBlur: _cache[15] || (_cache[15] = ($event: any) => (handleBlur('registeredVehicleNumber'))),
              maxlength: 50
            }, null, 8, ["value"]),
            (errors.registeredVehicleNumber)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(errors.registeredVehicleNumber), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[38] || (_cache[38] = _createElementVNode("label", { class: "field-label red-text" }, "*【事故発生年月日】", -1)),
            _createVNode(_component_a_date_picker, {
              value: formData.accidentDate,
              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((formData.accidentDate) = $event)),
              placeholder: "日付を選択してください",
              class: "custom-field",
              format: "YYYY/MM/DD",
              "value-format": "YYYY/MM/DD",
              "disabled-date": disabledDate,
              "input-read-only": true,
              onChange: _cache[17] || (_cache[17] = ($event: any) => (clearError('accidentDate'))),
              onBlur: _cache[18] || (_cache[18] = ($event: any) => (handleBlur('accidentDate')))
            }, null, 8, ["value"]),
            (errors.accidentDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(errors.accidentDate), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(TimeInput, {
              modelValue: formData.accidentTime,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.accidentTime) = $event)),
              label: "*【事故発生時刻】（14時30分の場合、1430と入力してください。）",
              required: true,
              "required-message": "事故発生時刻を入力してください。",
              "invalid-message": "有効な時間を入力してください 。",
              "invalid-hh-message": "0 から 23 までの有効な時間を入力してください 。",
              "invalid-mm-message": "00 から 59 まで有効な分を入力してください 。"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(CommonInput, {
              value: formData.accidentLocation,
              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((formData.accidentLocation) = $event)),
              label: "*事故場所",
              colLabel: "24",
              colSpan: "24",
              "is-custom-input": false,
              onInput: _cache[21] || (_cache[21] = ($event: any) => (clearError('accidentLocation'))),
              onBlur: _cache[22] || (_cache[22] = ($event: any) => (handleBlur('accidentLocation'))),
              maxlength: 300
            }, null, 8, ["value"]),
            (errors.accidentLocation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(errors.accidentLocation), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(CommonInput, {
              value: formData.driverNameKana,
              "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((formData.driverNameKana) = $event)),
              label: "運転されていた方のお名前（カナ）",
              colLabel: "24",
              colSpan: "24",
              "is-custom-input": false,
              maxlength: 70
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(CommonInput, {
              value: formData.driverName,
              "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((formData.driverName) = $event)),
              label: "運転されていた方のお名前",
              colLabel: "24",
              colSpan: "24",
              "is-custom-input": false,
              maxlength: 40
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_a_checkbox, {
              checked: formData.isContractorHimself,
              "onUpdate:checked": _cache[25] || (_cache[25] = ($event: any) => ((formData.isContractorHimself) = $event))
            }, {
              default: _withCtx(() => _cache[39] || (_cache[39] = [
                _createTextVNode(" ご契約者本人 ")
              ])),
              _: 1
            }, 8, ["checked"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _cache[40] || (_cache[40] = _createElementVNode("label", { class: "field-label" }, "性別", -1)),
            _createVNode(_component_a_select, {
              value: formData.gender,
              "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((formData.gender) = $event)),
              class: "custom-field",
              "allow-clear": "",
              disabled: formData.isContractorHimself
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(genderOptions, (option) => {
                  return _createVNode(_component_a_select_option, {
                    key: option.key,
                    value: option.key
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(option.description)), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["value", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _cache[41] || (_cache[41] = _createElementVNode("label", { class: "field-label" }, "【生年月日】", -1)),
            _createVNode(_component_a_date_picker, {
              placeholder: "日付を選択してください",
              value: formData.birthDate,
              "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((formData.birthDate) = $event)),
              class: "custom-field",
              format: "YYYY/MM/DD",
              "value-format": "YYYY/MM/DD",
              "input-read-only": true,
              disabled: formData.isContractorHimself,
              "disabled-date": disabledDate
            }, null, 8, ["value", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(CommonInput, {
              value: formData.age,
              "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((formData.age) = $event)),
              label: "年齢（半角数字で入力）",
              colLabel: "24",
              colSpan: "24",
              "is-custom-input": false,
              "is-age": true,
              maxlength: 3,
              disabled: formData.isContractorHimself,
              title: "年齢は半角で入力してください"
            }, null, 8, ["value", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(CommonInput, {
              value: formData.driverPhone,
              "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((formData.driverPhone) = $event)),
              label: "TEL（半角数字・14文字以内）",
              colLabel: "24",
              colSpan: "24",
              maxlength: 16,
              "is-custom-input": false,
              "is-phone-number": true,
              disabled: formData.isContractorHimself
            }, null, 8, ["value", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[42] || (_cache[42] = _createElementVNode("label", { class: "field-label" }, "ご契約者様との関係", -1)),
            _createVNode(_component_a_select, {
              value: formData.driverRelationshipWithContractor,
              "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((formData.driverRelationshipWithContractor) = $event)),
              class: "custom-field",
              "allow-clear": ""
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(driverRelationshipOptions, (option) => {
                  return _createVNode(_component_a_select_option, {
                    key: option.key,
                    value: option.key
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(option.description)), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_a_checkbox, {
              checked: formData.isSameAsContractedVehicle,
              "onUpdate:checked": _cache[31] || (_cache[31] = ($event: any) => ((formData.isSameAsContractedVehicle) = $event))
            }, {
              default: _withCtx(() => _cache[43] || (_cache[43] = [
                _createTextVNode(" 契約車両に同じ ")
              ])),
              _: 1
            }, 8, ["checked"])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(CommonInput, {
              value: formData.accidentVehicleNumber,
              "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((formData.accidentVehicleNumber) = $event)),
              label: "事故車両登録番号（例：品川500あ1234）",
              colLabel: "24",
              colSpan: "24",
              "is-custom-input": false,
              "is-number-plate": true,
              disabled: formData.isSameAsContractedVehicle,
              maxlength: 50
            }, null, 8, ["value", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[44] || (_cache[44] = _createElementVNode("label", { class: "field-label" }, [
              _createElementVNode("span", { class: "red-text" }, "*事故状況について簡潔で構いませんのでご記入ください"),
              _createElementVNode("br"),
              _createTextVNode(" 例①：車対車事故。交差点を直進したところ、対向右折車両と接触した。"),
              _createElementVNode("br"),
              _createTextVNode(" 例②：走行中にハンドル操作を誤り、道路わきの民家の壁と接触した。 ")
            ], -1)),
            _createVNode(CommonInput, {
              value: formData.accidentDetails,
              "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((formData.accidentDetails) = $event)),
              label: "",
              colLabel: "24",
              colSpan: "24",
              "is-custom-input": false,
              onInput: _cache[34] || (_cache[34] = ($event: any) => (clearError('accidentDetails'))),
              onBlur: _cache[35] || (_cache[35] = ($event: any) => (handleBlur('accidentDetails'))),
              maxlength: 300
            }, null, 8, ["value"]),
            (errors.accidentDetails)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(errors.accidentDetails), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(CommonInput, {
              value: formData.otherNotes,
              "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((formData.otherNotes) = $event)),
              label: "その他連絡事項※ご連絡事項等ございましたらご入力ください",
              colLabel: "24",
              colSpan: "24",
              "is-custom-input": false,
              maxlength: 300
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_a_button, {
              onClick: handleSubmit,
              block: "",
              class: "submit-btn"
            }, {
              default: _withCtx(() => _cache[45] || (_cache[45] = [
                _createTextVNode(" 送信 ")
              ])),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})